import { EventEmitter, Input, Output, Directive, HostBinding, HostListener } from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';
import { ENTER } from '@angular/cdk/keycodes';
import { Record, RecordType } from '../components/account-search/account-search.model';

@Directive({
    selector: 'tr[search-result-row], [searchResultRow]',
    exportAs: 'searchResultRow'
})
export class SearchResultRowDirective implements Highlightable {
  private _active = false;

  @Input() type: RecordType;

  @Input() value: any;

  @Output() selected = new EventEmitter<any>();

  @HostBinding('class') class = 'search-result-row';
  @HostBinding('attr.role') role = 'row';
  @HostBinding('attr.tabindex') tabindex = 0;

  @HostBinding('class.row-active')
  get active(): boolean {
    return this._active;
  }

  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (event.keyCode === ENTER) {
      this.selectViaInteraction();
      event.preventDefault();
    }
  }

  @HostListener('click')
  selectViaInteraction(): void {
    this.selected.emit(this.value);
  }

  setActiveStyles(): void {
    this._active = true;
  }

  setInactiveStyles(): void {
    this._active = false;
  }

  getLabel(): string {
    if (this.type === RecordType.Symbol) {
      return this.value.symbolName;
    }
    return this.value.accountName;
  }
}
